/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Skriv noe',
	'About Jodit': 'Om Jodit',
	'Jodit Editor': 'Jodit-redigerer',
	"Jodit User's Guide": 'Jodit brukerveiledning',
	'contains detailed help for using': 'Inneholder detaljert hjelp for bruk',
	'For information about the license, please go to our website:':
		'For informasjon om lisensen, besøk vår nettside:',
	'Buy full version': 'Kjøp fullversjon',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Opphavsrett © XDSoft.net - Chupurnov Valeriy. Alle rettigheter forbeholdt.',
	Anchor: 'Anker',
	'Open in new tab': 'Åpne i ny fane',
	'Open in fullsize': 'Åpne i fullskjerm',
	'Clear Formatting': 'Fjern formatering',
	'Fill color or set the text color': 'Endre bakgrunns- eller tekstfarge',
	Redo: 'Gjør om',
	Undo: 'Angre',
	Bold: 'Fet',
	Italic: 'Kursiv',
	'Insert Unordered List': 'Sett inn punktliste',
	'Insert Ordered List': 'Sett inn nummerert liste',
	'Align Center': 'Midtstill',
	'Align Justify': 'Juster',
	'Align Left': 'Venstrejuster',
	'Align Right': 'Høyrejuster',
	'Insert Horizontal Line': 'Sett inn horisontal linje',
	'Insert Image': 'Sett inn bilde',
	'Insert file': 'Sett inn fil',
	'Insert youtube/vimeo video': 'Sett inn YouTube/Vimeo-video',
	'Insert link': 'Sett inn lenke',
	'Font size': 'Skriftstørrelse',
	'Font family': 'Skriftfamilie',
	'Insert format block': 'Sett inn formateringsblokk',
	Normal: 'Normal',
	'Heading 1': 'Overskrift 1',
	'Heading 2': 'Overskrift 2',
	'Heading 3': 'Overskrift 3',
	'Heading 4': 'Overskrift 4',
	Quote: 'Sitat',
	Code: 'Kode',
	Insert: 'Sett inn',
	'Insert table': 'Sett inn tabell',
	'Decrease Indent': 'Reduser innrykk',
	'Increase Indent': 'Øk innrykk',
	'Select Special Character': 'Velg spesialtegn',
	'Insert Special Character': 'Sett inn spesialtegn',
	'Paint format': 'Kopier format',
	'Change mode': 'Bytt modus (WYSIWYG/HTML)',
	Margins: 'Marger',
	top: 'topp',
	right: 'høyre',
	bottom: 'bunn',
	left: 'venstre',
	Styles: 'Stiler',
	Classes: 'Klasser',
	Align: 'Justering',
	Right: 'Høyre',
	Center: 'Senter',
	Left: 'Venstre',
	'--Not Set--': '--Ikke satt--',
	Src: 'Kilde',
	Title: 'Tittel',
	Alternative: 'Alternativ',
	Filter: 'Filter',
	Link: 'Lenke',
	'Open link in new tab': 'Åpne lenke i ny fane',
	Image: 'Bilde',
	file: 'fil',
	Advanced: 'Avansert',
	'Image properties': 'Bildeegenskaper',
	Cancel: 'Avbryt',
	Ok: 'OK',
	'Your code is similar to HTML. Keep as HTML?':
		'Koden din ligner HTML. Beholde som HTML?',
	'Paste as HTML': 'Lim inn som HTML',
	Keep: 'Behold',
	Clean: 'Rens',
	'Insert as Text': 'Lim inn som tekst',
	'Word Paste Detected': 'Word-innliming oppdaget',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Innholdet du limer inn kommer fra et Microsoft Word/Excel-dokument. Vil du beholde formatet eller rense det?',
	'Insert only Text': 'Lim inn kun tekst',
	'File Browser': 'Filutforsker',
	'Error on load list': 'Feil ved lasting av liste',
	'Error on load folders': 'Feil ved lasting av mapper',
	'Are you sure?': 'Er du sikker?',
	'Enter Directory name': 'Skriv inn mappenavn',
	'Create directory': 'Opprett mappe',
	'type name': 'skriv navn',
	'Drop image': 'Slipp bilde',
	'Drop file': 'Slipp fil',
	'or click': 'eller klikk',
	'Alternative text': 'Alternativ tekst',
	Browse: 'Bla gjennom',
	Upload: 'Last opp',
	Background: 'Bakgrunn',
	Border: 'Kantlinje',
	Text: 'Tekst',
	Top: 'Topp',
	Middle: 'Midt',
	Bottom: 'Bunn',
	'Insert column before': 'Sett inn kolonne før',
	'Insert column after': 'Sett inn kolonne etter',
	'Insert row above': 'Sett inn rad over',
	'Insert row below': 'Sett inn rad under',
	'Delete table': 'Slett tabell',
	'Delete row': 'Slett rad',
	'Delete column': 'Slett kolonne',
	'Empty cell': 'Tøm celle',
	'Chars: %d': 'Tegn: %d',
	'Words: %d': 'Ord: %d',
	Split: 'Del',
	'Split vertical': 'Del vertikalt',
	'Split horizontal': 'Del horisontalt',
	'Strike through': 'Gjennomstreking',
	Underline: 'Understreking',
	superscript: 'hevet skrift',
	subscript: 'senket skrift',
	'Cut selection': 'Klipp ut markering',
	'Select all': 'Velg alt',
	Break: 'Pause',
	'Search for': 'Søk etter',
	'Replace with': 'Erstatt med',
	Replace: 'Erstatt',
	Paste: 'Lim inn',
	'Choose Content to Paste': 'Velg innhold å lime inn',
	source: 'kilde',
	bold: 'fet',
	italic: 'kursiv',
	brush: 'pensel',
	link: 'lenke',
	undo: 'angre',
	redo: 'gjør om',
	table: 'tabell',
	image: 'bilde',
	eraser: 'viskelær',
	paragraph: 'avsnitt',
	fontsize: 'skriftstørrelse',
	video: 'video',
	font: 'skrift',
	about: 'om redigeringsverktøyet',
	print: 'skriv ut',
	underline: 'understreking',
	strikethrough: 'gjennomstreking',
	indent: 'innrykk',
	outdent: 'reduser innrykk',
	fullsize: 'full størrelse',
	shrink: 'krympe',
	hr: 'linje',
	ul: 'punktliste',
	ol: 'nummerert liste',
	cut: 'klipp ut',
	selectall: 'velg alt',
	'Open link': 'Åpne lenke',
	'Edit link': 'Rediger lenke',
	'No follow': 'Ingen oppfølging',
	Unlink: 'Fjern lenke',
	Eye: 'Forhåndsvisning',
	pencil: 'Rediger',
	' URL': 'URL',
	Reset: 'Tilbakestill',
	Save: 'Lagre',
	'Save as ...': 'Lagre som ...',
	Resize: 'Endre størrelse',
	Crop: 'Beskjær',
	Width: 'Bredde',
	Height: 'Høyde',
	'Keep Aspect Ratio': 'Behold proporsjoner',
	Yes: 'Ja',
	No: 'Nei',
	Remove: 'Fjern',
	Select: 'Velg',
	'Select %s': 'Velg: %s',
	Update: 'Oppdater',
	'Vertical align': 'Vertikal justering',
	Merge: 'Slå sammen',
	'Add column': 'Legg til kolonne',
	'Add row': 'Legg til rad',
	Delete: 'Slett',
	'Horizontal align': 'Horisontal justering',
	'Sort by changed': 'Sorter etter endring',
	'Sort by name': 'Sorter etter navn',
	'Sort by size': 'Sorter etter størrelse',
	'Add folder': 'Legg til mappe',
	palette: 'Palett',
	preview: 'Forhåndsvisning',
	'Line height': 'Linjehøyde',
	'Insert className': 'Sett inn klassenavn',
	apply: 'Bruk',
	edit: 'Rediger',
	'Show all': 'Vis alle',
	sound: 'Lyd',
	'Interim Results': 'Foreløpige resultater',
	default: 'Standard',
	circle: 'Sirkel',
	dot: 'Punkt',
	square: 'Firkant',
	'Press Alt for custom resizing': 'Trykk på Alt for å endre størrelse',
	'Copy selection': 'Kopier utvalg',
	'Paste from clipboard': 'Lim inn fra utklippstavlen',
	Find: 'Finne'
};
